import { request } from '@helpers/request';

export const getTenantBillingDataApi = () => request('tenant-billing');

export const updateTenantBillingDataApi = (email: string) => request('tenant-billing', undefined, { email }, 'PATCH');
